import React from 'react';

import { fetchZones, saveZones } from 'helpers/zonesHelpers';

const { Provider, Consumer } = React.createContext();

export class Zones extends React.Component {
  state = {};

  componentDidMount () {
    this.loadZones();
  }

  componentWillUnmount () {
    this.isCancelled = true;
  }

  selectZoneByUser = uuid => {
    const { zones, selectedZone: currentSelectedZone } = this.state;

    if (!zones) return setTimeout(() => this.selectZoneByUser(uuid), 10);

    const { properties: { CCOD_PST: currentUUID } = {} } = currentSelectedZone || {};

    if (!uuid ||
        !zones ||
        currentUUID === uuid) return null;

    const selectedZone = zones.features.find(({ properties: { CCOD_PST } }) => uuid === CCOD_PST);

    if (selectedZone) {
      this.setState({ selectedZone });
    }

    return null;
  }

  selectZoneById = id => {
    const { zones } = this.state;

    if (!zones) return setTimeout(() => this.selectZoneById(id), 10);

    const selectedZone = zones.features.find(({ properties: { tmpId } }) => tmpId === id);

    if (selectedZone) {
      this.setState({ selectedZone });
    }

    return null;
  }

  unSelectZone = () => {
    const { selectedZone } = this.state;
    if (selectedZone) {
      this.setState({ selectedZone: null });
    }
  };

  changeZoneOwner = (prevOwner, newOwner) => {
    if (prevOwner === newOwner) return;

    const { zones } = this.state;

    if (!zones) return;

    const features = zones
      .features
      .filter(({ properties: { CCOD_PST } }) => CCOD_PST === prevOwner);

    if (!features.length) return;

    saveZones(features.map(feature => ({
      ...feature,
      properties: {
        ...feature.properties,
        CCOD_PST: newOwner,
      },
    })));
  };

  async loadZones () {
    const zones = await fetchZones();

    if (!zones || this.isCancelled) return;

    this.setState({
      zones,
    });
  }

  render () {
    const { children } = this.props;
    const { selectZoneById, selectZoneByUser, unSelectZone, changeZoneOwner } = this;
    const value = {
      ...this.state,
      selectZoneById,
      selectZoneByUser,
      unSelectZone,
      changeZoneOwner,
    };

    return (
      <Provider
        value={value}
      >
        {children}
      </Provider>
    );
  }
}

export const withZones = WrappedComponent => props => (
  <Consumer>
    {zonesProps => (
      <WrappedComponent
        {...zonesProps}
        {...props}
      />
    )}
  </Consumer>
);

export default Zones;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/Zones/index.js